import Api from '../resources/Api';
import router from '../router';

const defaultData = {
  user: {
    id: null,
    name: null,
    username: null,
    rule: null,
    permissions: [],
    cpf: null,
    email: null,
    token: null
  }
};

const data = {
  namespaced: true,
  state: {
    user: defaultData.user
  },

  mutations: {
    updateUser: (state, user) => {
      state.user = Object.assign(state.user, user);
    },

    logout: state => {
      (state.user = _.clone(defaultData.user)), router.push('/login', () => {});
    }
  },

  actions: {
    async getUserInfo(context) {
      const result = await Api.me();
      context.commit('updateUser', result.data.user);
    }
  },

  getters: {
    token: state => {
      return state.user.token;
    },

    isLogged: state => {
      return !_.isEmpty(state.user.token);
    }
  }
};

export default data;
